import PropTypes from 'prop-types';
import React from 'react';

function getSelectedAttribute(isSelected) {
    if (isSelected) {
        return { 'data-button-selected': true };
    } else {
        return {};
    }
}

const GroupByDesignerControl = ({ title, selected }) => (
    <div className="button-group button-group--joined">
        <div className="button-group__item">
            <label
                htmlFor="grid_view"
                className="button button--secondary button--joined button--first button--icon-no-label"
                title={title}
                {...getSelectedAttribute('none' === selected)}
            >
                <div className="button__inner">
                    <span className="button__icon">
                        <input
                            id="grid_view"
                            type="radio"
                            name="groupby"
                            value="none"
                            data-broadcasting-input
                        />
                        <span className="icon icon--grid-2" />
                    </span>
                </div>
            </label>
        </div>
        <div className="button-group__item">
            <label
                htmlFor="list_view"
                className="button button--secondary button--joined button--last button--icon-no-label"
                title={title}
                {...getSelectedAttribute('designer' === selected)}
            >
                <div className="button__inner">
                    <span className="button__icon">
                        <input
                            id="list_view"
                            type="radio"
                            name="groupby"
                            value="designer"
                            data-broadcasting-input
                        />
                        <span className="icon icon--notebook-3" />
                    </span>
                </div>
            </label>
        </div>
    </div>
);

GroupByDesignerControl.propTypes = {
    title: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
};

export default GroupByDesignerControl;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/group-by-designer-control.js